const table_filter = {
	pagination: {
		from: "von",
		more_than: "mehr als",
		rows_per_page: "Zeilen pro Seite",
	},
	table_row_empty: "Keine Ergebnisse gefunden...",
	toolbar: {
		reset: "Zurücksetzen",
		search: "In Tabelle suchen",
	},
};

export default table_filter;
